'use strict';

let scrollTop: number;

const closer: HTMLElement = document.querySelector('.doc-viewer-close')!;

function removeHash() {
    var scrollV, scrollH, loc = window.location;
    if ('pushState' in history)
        history.pushState("", document.title, loc.pathname + loc.search);
    else {
        // Prevent scrolling by storing the page's current scroll offset
        scrollV = document.body.scrollTop;
        scrollH = document.body.scrollLeft;

        loc.hash = "";

        // Restore the scroll offset, should be flicker free
        document.body.scrollTop = scrollV;
        document.body.scrollLeft = scrollH;
    }
}

function showDocument(id: string): boolean {
    const doc = document.querySelector('.doc-view-frame.' + id);
    if (!doc) {
        console.warn('no document found for: ' + id)
        return false;
    };

    scrollTop = window.scrollY
    document.body.classList.add('noscroll');
    doc.classList.add('visible');
    closer.classList.add('visible');
    closer.dataset.docid = id;

    return false;
};

function closeDocument() {
    if (!document.body.classList.contains('noscroll')) return;
    document.body.classList.remove("noscroll");
    const docID = closer.dataset.docid;

    document.querySelector('.doc-view-frame.' + docID)?.classList.remove('visible');
    closer.classList.remove('visible');
    removeHash();
    window.scrollTo({ top: scrollTop, behavior: 'instant' })
}

function showOnHash() {
    const hash = window.location.hash;
    if (!hash.startsWith('#doc=')) return;
    const docID = hash.substring(5);
    showDocument(docID);
}

document.querySelectorAll('a[href^="#doc="]').forEach(el => {
    el.addEventListener('click', function () {
        const docID = el.attributes.getNamedItem('href')!.value.substring(5);
        showDocument(docID);
    });
});

closer.addEventListener('click', closeDocument);
document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDocument();
})

showOnHash();

export { };
